import apiClient from './client'

export default {
  get() {
    return apiClient.get('/featured_trail')
  },
}
